import { ProductOrigin } from '../../interfaces/Producto/ProductOrigins'
import {
  GET_PRODUCTORIGINS_EXITO,
  GET_PRODUCTORIGINS
} from '../types/productOriginsTypes'

export type ProductOriginAction =
  | ProductOriginsAction
  | ProductOriginsActionAsync

// Esto va a REDUX
export interface ProductOriginsAction {
  type: typeof GET_PRODUCTORIGINS_EXITO
  productOrigins: ProductOrigin[] | undefined
  error: string | undefined
}

export const getProductOriginsAction = (
  productOrigins?: ProductOrigin[],
  error?: string
): ProductOriginsAction => {
  return {
    type: GET_PRODUCTORIGINS_EXITO,
    productOrigins: productOrigins,
    error
  }
}

// Esto va a SAGA
export interface ProductOriginsActionAsync {
  type: typeof GET_PRODUCTORIGINS
}

export const getProductOriginsActionAsync = (): ProductOriginsActionAsync => {
  return {
    type: GET_PRODUCTORIGINS
  }
}
